import api from '@/api';

const getters = {
  courseLanguages: state => state.courseLanguages || [],
};

export const mutations = {
  SET_COURSE_LANGUAGES(state, { courseLanguages }) {
    state.courseLanguages = courseLanguages;
  },
};

export const actions = {
  FETCH_COURSE_LANGUAGES: ({ commit, state }) => {
    return new Promise(resolve => {
      if (state.courseLanguages) return resolve(state.courseLanguages);

      return api.fetchCourseLanguages().then(courseLanguages => {
        commit('SET_COURSE_LANGUAGES', { courseLanguages });
        resolve(courseLanguages);
      });
    });
  },
};

const state = {
  courseLanguages: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
